import { render, staticRenderFns } from "./RangchaList.vue?vue&type=template&id=45555adb&scoped=true"
import script from "./RangchaList.vue?vue&type=script&lang=js"
export * from "./RangchaList.vue?vue&type=script&lang=js"
import style0 from "./RangchaList.vue?vue&type=style&index=0&id=45555adb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45555adb",
  null
  
)

export default component.exports